export { default } from 'dialog-polyfill';

